import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import decryptCookieData from "./Functions/decryptCookieData";

const PaymentSuccess = ({ fetchCart }) => {
  const { id } = useParams();

  const userData =
    JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || null;
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const url = process.env.REACT_APP_API_URL;

  const fetchTransaction = async () => {
    try {
      const response = await fetch(`${url}/payment/order/${id}`);
      const res = await response.json();
      setData(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const CartEmpty = async () => {
    try {
      const response = await fetch(
        `${url}/cart/deleteall/${userData.user_id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const res = await response.json();
      if (response.ok) {
        localStorage.removeItem("checkout_data");
        fetchCart(userData.user_id);
        setTimeout(() => {
          navigate("/my-account"); // 👈 Redirect to home after 2 seconds
        }, 5000);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const formatISTDateTime = (isoString) => {
    if (!isoString) return "";

    const date = new Date(isoString);

    // Convert to IST
    const ISTOffset = 5.5 * 60 * 60 * 1000; // 5 hours 30 minutes in ms
    const istDate = new Date(date.getTime() + ISTOffset);

    const day = String(istDate.getDate()).padStart(2, "0");
    const month = String(istDate.getMonth() + 1).padStart(2, "0");
    const year = String(istDate.getFullYear()).slice(-2); // Last two digits
    const hours = String(istDate.getHours()).padStart(2, "0");
    const minutes = String(istDate.getMinutes()).padStart(2, "0");

    return `${day}/${month}/${year} - ${hours}:${minutes}`;
  };

  const formatDeliveryDate = (isoString) => {
    if (!isoString) return "";

    const date = new Date(isoString);

    // Add IST offset
    const ISTOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(date.getTime() + ISTOffset);

    // Format DD/MM/YYYY
    const day = String(istDate.getDate()).padStart(2, "0");
    const month = String(istDate.getMonth() + 1).padStart(2, "0");
    const year = istDate.getFullYear();

    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    fetchTransaction();
    CartEmpty();
  }, []);
  return (
    <div className="hbtsuccessmainpay">
      <div className="success-card-perfume">
        <button className="success-close-perfume">
          <i className="fa-solid fa-xmark"></i>
        </button>
        <div className="success-header-perfume">
          <i className="fa-solid fa-circle-check success-icon-perfume"></i>
          <h2 className="success-title-perfume">Payment Successful</h2>
          <p className="success-text-perfume">Thank you for your order!</p>
          <div className="success-transaction-perfume">
            <i className="fa-solid fa-clipboard success-clipboard-perfume"></i>
            <span>#{data.order_id}</span>
          </div>
        </div>
        <div className="success-details-perfume">
          <div className="success-row-perfume">
            <span>Time / Date</span>
            <span>{formatISTDateTime(data.createdAt)}</span>
          </div>
          <div className="success-row-perfume">
            <span>Ref Number</span>
            <span>{data.order_id}</span>
          </div>
          <div className="success-row-perfume">
            <span>Delivery Date</span>
            <span>{formatDeliveryDate(data.delivery_date)}</span>
          </div>
          <div className="success-row-perfume">
            <span>Payment Method</span>
            <span>{data?.payment_mode}</span>
          </div>
          <div className="success-row-perfume">
            <span>Sender Name</span>
            <span>{data.user_name}</span>
          </div>
          {data.payment_mode === "Pay on delivery" ? (
            <div className="success-row-perfume">
              <span>Advance Paid</span>
              <span>₹{data.amountafterdiscount}</span>
            </div>
          ) : null}
          {data.payment_mode === "Pay on delivery" ? (
            <div className="success-row-perfume">
              <span>Remaining Amount</span>
              <span>₹{data.remaining_amount}</span>
            </div>
          ) : null}
        </div>
        <div className="success-summary-perfume">
          <div className="success-summary-row-perfume">
            <span>Amount</span>
            <span>
              ₹
              {Number(data.totalAmountbeforePay) -
                Number(data.deliveryCharge || 0)}
            </span>
          </div>
          <div className="success-summary-row-perfume">
            <span>Delivery Charge</span>
            <span>₹{data.deliveryCharge}</span>
          </div>
          <div className="success-summary-row-perfume">
            <span>Fee</span>
            <span>₹0</span>
          </div>
          <div className="success-summary-row-perfume success-total-perfume">
            <span>Total</span>
            <span>₹{Number(data.totalAmountbeforePay)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
